<lib-create-sb-user-wizard #rootWizard 
[minimumPwdLength]="minimumPwdLength"
[minimumPwdScore]="minimumPwdScore"
[passwordScorerFn]="passwordScorerFn"
[userGroups]="userGroups"
[emailTakenFn]="emailTakenFn"
[optionalContactModel]="optionalContactModel"
[subscriptionBasedApp]="subscriptionBasedApp"
(wizardCompletedEmitter)="wizardCompletedEmitter.emit($event)"
(wizardCancelledEmitter)="wizardCancelledEmitter.emit($event)"
(initializedEmitter)="setupWizard()">
    <ng-content></ng-content>
</lib-create-sb-user-wizard>
<ng-template #createSbUserStep2Override let-wrapperForm="wrapperForm">
    <div class="row">
        <div class="form-group col-5 mb-2">
            <label for="username" class="form-label">
                <i class="fal fa-lg fa-id-card-alt me-1"></i>
                User's display name
            </label>
            <input type="text" placeholder="Display name within the app"
                [formControl]="wrapperForm.controls['userName']" required
                matTooltip="The user will be able to adjust this" class="form-control editable">
            <lib-form-error [control]="wrapperForm.controls['userName']"></lib-form-error>
        </div>
    </div>
    <div class="form-row mb-2">
        <div class="form-check-inline form-check col">
            <label for="adminChk" class="form-check-label me-1">
                <i class="fal fa-fw fa-lg fa-user-astronaut me-1"
                    [style.color]="adminChk.checked ? 'black' : 'gray'"></i>
                Administrator
            </label>
            <input type="checkbox" class="form-check-input ms-1" #adminChk name="adminChk" id="adminChk"
                [formControl]="wrapperForm['controls']['admin']">
            <a style="font-size: smaller; color: dodgerblue; cursor: default;" class="ms-1 btn-sm btn-link"
                matTooltip="Admins can perform almost any action in the system, including managing users and deleting data.">Details</a>
        </div>
    </div>
    <div class="form-row mb-2">
        <div class="form-check-inline form-check col-6">
            <label for="subscribedChk" class="form-check-label me-1">
                <i class="fal fa-fw fa-lg fa-credit-card me-1"
                    [style.color]="subscribedChk.checked ? 'black' : 'gray'"></i>
                Free account (subscribed)
            </label>
            <input type="checkbox" class="form-check-input ms-1" #subscribedChk name="subscribedChk" id="subscribedChk"
                [formControl]="wrapperForm['controls']['subscribed']"
                (change)="showExpiryDateField = !showExpiryDateField">
        </div>
    </div>
    <div class="form-row mb-2">
        <div class="form-inline col" *ngIf="showExpiryDateField">
            <label for="subscriptionExpiryDate" class="form-label me-2">
                <i class="fal fa-fw fa-lg fa-calendar-day me-1"></i>
                Free account expiration
            </label>
            <input type="date" class="form-control editable" name="subscriptionExpiryDate" id="subscriptionExpiryDate"
                min="{{ today | date:'yyyy-MM-dd'}}" [formControl]="wrapperForm['controls']['subscriptionExpiryDate']">
            <div class="text-danger ms-2"
                *ngIf="(wrapperForm.controls['subscriptionExpiryDate'].dirty || wrapperForm.controls['subscriptionExpiryDate'].touched) && wrapperForm.controls['subscriptionExpiryDate'].errors?.min">
                <small>Date must be in the future.</small>
            </div>
        </div>
    </div>
</ng-template>